export { default as ActivitySchedule } from './ActivitySchedule/index.js'
export type { ActivityScheduleProps, ActivityScheduleData, ActivityScheduleItem } from './ActivitySchedule/types.js'
export { default as GiftShelf } from './GiftShelf/index.js'
export type {
  GiftShelfProps,
  GiftShelfData,
  GiftShelfItem,
  CountdownConfig,
  ResponsiveBackgroundImage as GiftShelfResponsiveBackgroundImage,
} from './GiftShelf/types.js'
export { default as GiftTierShelf } from './GiftTierShelf/index.js'
export type { GiftTierShelfProps, GiftTierShelfData, GiftTierItem, GiftTierProduct } from './GiftTierShelf/types.js'
export { default as ActivityMechanism } from './ActivityMechanism/index.js'
export type {
  ActivityMechanismProps,
  ActivityMechanismItem,
  ActivityMechanismSemanticName,
  ResponsiveBackgroundImage,
} from './ActivityMechanism/types.js'
export { default as BrandEquity } from './BrandEquity/index.js'
export { default as MemberEquity } from './MemberEquity/index.js'
export { default as Slogan } from './Slogan/index.js'
export { default as Title } from './Title/index.js'
export { default as Spacer } from './Spacer/index.js'
export { default as ShelfDisplay } from './ShelfDisplay/index.js'
export { default as Evaluate } from './Evaluate/index.js'
export { default as Category } from './Category/index.js'
export { default as HeroBanner } from './HeroBanner/index.js'
export { default as AccordionCards } from './AccordionCards/index.js'
export { default as Graphic } from './Graphic/index.js'
export { default as MediaPlayerBase } from './MediaPlayerBase/index.js'
export { default as MediaPlayerSticky } from './MediaPlayerSticky/index.js'
export { default as MediaPlayerMulti } from './MediaPlayerMulti/index.js'
export { default as Marquee } from './Marquee/index.js'
export { default as MarqueeReview } from './MarqueeReview/index.js'
export type { MarqueeReviewProps, MarqueeReviewData, ReviewItem } from './MarqueeReview/index.js'
export { default as WhyChoose } from './WhyChoose/index.js'
export { default as Faq } from './Faq/index.js'
export { MarqueeItem, MarqueeImageContent, MarqueeTextContent } from './Marquee/index.js'
export { default as MultiLayoutGraphicBlock } from './MultiLayoutGraphicBlock/index.js'
export type { MultiLayoutGraphicBlockProps } from './MultiLayoutGraphicBlock/index.js'
export { default as GraphicAttractionBlock } from './GraphicAttractionBlock/index.js'
export type { GraphicAttractionBlockProps } from './GraphicAttractionBlock/index.js'
export { default as HeaderNavigation } from './HeaderNavigation/index.js'
export { default as FooterNavigation } from './FooterNavigation/index.js'
export { default as SearchPage } from './SearchPage/index.js'
export type { SearchPageProps } from './SearchPage/types.js'
export { IPC_SEARCH_PAGE, SearchPageTabType } from './SearchPage/types.js'

export { withLayout } from '../shared/Styles.js'
export { default as AiuiProvider } from './AiuiProvider/index.js'
export { default as Tabs } from './Tabs/index.js'
export { default as CreativeModule } from './CreativeModule/index.js'
export { default as GraphicOverlay } from './GraphicOverlay/index.js'
export { default as Specs } from './Specs/index.js'
export { default as TabGroup } from './TabsGroup/index.js'

export { default as BizProductProvider } from './Listing/BizProductProvider.js'
export { default as PurchaseBar } from './Listing/components/PurchaseBar/index.js'
export { default as ProductActions } from './Listing/components/PurchaseBar/ProductActions/index.js'
export type { ProductActionsProps } from './Listing/components/PurchaseBar/ProductActions/index.js'
export { default as ProductCard } from './Listing/components/ProductCard/index.js'
export { default as ProductBenefitsTabs } from './Listing/components/ProductCard/ProductDetail/ProductBenefitsTabs/index.js'
export { default as ProductBenefits } from './Listing/components/ProductCard/ProductDetail/ProductBenefits/index.js'
export { default as ProductHighlight } from './Listing/components/ProductCard/ProductDetail/ProductHighlight/index.js'
export { default as ProductFreeGift } from './Listing/components/ProductCard/ProductDetail/ProductFreeGift/index.js'
export { default as ProductExchangePurchase } from './Listing/components/ProductCard/ProductDetail/ProductExchangePurchase/index.js'
export { default as ProductOptions } from './Listing/components/ProductCard/ProductDetail/ProductOptions/index.js'
export { default as ProductBundle } from './Listing/components/ProductCard/ProductDetail/ProductBundle/index.js'
export { default as ProductCoupon } from './Listing/components/ProductCard/ProductDetail/ProductCoupon/index.js'
export { default as ProductBanner } from './Listing/components/ProductCard/ProductDetail/ProductBanner/index.js'
export { default as ProductGridBox } from './Listing/components/ProductCard/ProductGridBox.js'
export { default as ProductGallery } from './Listing/components/ProductCard/ProductGallery/index.js'
export { default as ProductDetail } from './Listing/components/ProductCard/ProductDetail/index.js'
export { default as ProductSummary } from './Listing/components/ProductCard/ProductSummary/index.js'
export { default as BenefitsTab } from './Listing/components/ProductCard/ProductDetail/BenefitsTab.js'
export { default as PaidShipping } from './Listing/components/PaidShipping/index.js'
export { default as ProductPaidShipping } from './Listing/components/ProductCard/ProductPaidShipping/index.js'

export { default as GraphicMore } from './GraphicMore/index.js'
export { default as Features } from './Features/index.js'
export { default as AplusDesc } from './AplusDesc/index.js'
export { default as GiftBox } from './GiftBox/index.js'
export { default as SelectStore } from './SelectStore/index.js'
export { default as DownLoad } from './DownLoad/index.js'
export { default as FootCharger } from './FootCharger/index.js'
export { default as BrandCardLink } from './BrandCardLink/index.js'
export type { BrandCardLinkProps, BrandCardLinkItemProps } from './BrandCardLink/types.js'

export * as IPRedirect from './IPRedirect/index.js'

export { default as WheelLottery } from './WheelLottery/index.js'
export type {
  WheelLotteryProps,
  WheelLotteryHandle,
  Prize,
  ChanceMethod,
  WinningInfo,
  UserData,
} from './WheelLottery/types.js'
export { default as ProductLottery } from './ProductLottery/index.js'
export type { ProductLotteryProps, ProductLotteryHandle, MediaConfig, CtaButtonConfig } from './ProductLottery/types.js'
export { default as ProductCompare } from './ProductCompare/index.js'
export type { ProductCompareProps, ProductItemData } from './ProductCompare/index.js'
export { default as Ksp } from './Ksp/index.js'
export type { KspProps, KspData, KspCardItem } from './Ksp/index.js'
export { default as ImageTextFeature } from './ImageTextFeature/index.js'
export type { ImageTextFeatureProps, ImageTextFeatureItem } from './ImageTextFeature/index.js'
export { default as FeatureCards } from './FeatureCards/index.js'
export type { FeatureCardsProps, FeatureCardItem } from './FeatureCards/index.js'
export { default as FeaturedBlogPosts } from './FeaturedBlogPosts/index.js'
export type {
  FeaturedBlogPostsProps,
  FeaturedBlogPostsData,
  FeaturedBlogPostItem,
  FeaturedBlogPostSpan,
} from './FeaturedBlogPosts/index.js'
export { default as ImageWithText } from './ImageWithText/index.js'
export type { ImageWithTextProps } from './ImageWithText/index.js'
export { default as VideoFeature } from './VideoFeature/index.js'
export type { VideoFeatureProps } from './VideoFeature/index.js'
export { default as TabsWithMedia } from './TabsWithMedia/index.js'
export type { TabsWithMediaProps, TabItem, TimeIndex } from './TabsWithMedia/index.js'
export { default as TabWithImage } from './TabWithImage/index.js'
export type { TabWithImageProps, TabWithImageDataItem } from './TabWithImage/index.js'
export { default as FeatureShowcase } from './FeatureShowcase/index.js'
export type { FeatureShowcaseProps, FeatureShowcaseItem } from './FeatureShowcase/index.js'
export { default as ProductHero } from './ProductHero/index.js'
export type { ProductHeroProps } from './ProductHero/index.js'
export { default as SpecsComparison } from './SpecsComparison/index.js'
export type {
  SpecsComparisonProps,
  SpecsComparisonMenuItem,
  SpecsComparisonLeftMenuItem,
} from './SpecsComparison/index.js'
export { default as MediaSceneSwitcher } from './MediaSceneSwitcher/index.js'
export type { MediaSceneSwitcherProps } from './MediaSceneSwitcher/types.js'
export { default as MediaSceneSwitcherV2 } from './MediaSceneSwitcherV2/index.js'
export type {
  MediaSceneSwitcherV2Props,
  MediaSceneSwitcherV2Data,
  MediaSceneSwitcherV2Item,
  MediaSceneSwitcherV2Layout,
} from './MediaSceneSwitcherV2/index.js'
export { default as ThreeDCarousel } from './ThreeDCarousel/index.js'
export type { ThreeDCarouselProps } from './ThreeDCarousel/index.js'
export { default as ProductNav } from './ProductNav/index.js'
export type { ProductNavProps, TabLink, AnchorItem, BuyButton } from './ProductNav/index.js'
export { default as AnchorNavigation } from './AnchorNavigation/index.js'
export { default as PromotionalBar } from './PromotionalBar/index.js'
export { default as EventSchedule } from './EventSchedule/index.js'
export { default as SecondaryBanner } from './SecondaryBanner/index.js'
export { default as BuyOneGetOneShelf } from './BuyOneGetOneShelf/index.js'
export { default as ActiveShelf } from './ActiveShelf/index.js'
export { default as MediaShelf } from './MediaShelf/index.js'
export { default as CreditsShelf, CreditsProductCard } from './CreditsShelf/index.js'
export type {
  CreditsShelfSemanticName,
  CreditsProductCardData,
  CopyConfig as CreditsShelfCopyConfig,
  ButtonFunctionType as CreditsShelfButtonFunctionType,
} from './CreditsShelf/index.js'
export { default as SceneShelf, SceneProductCard } from './SceneShelf/index.js'
export type { SceneShelfSemanticName, SceneProductCardData, SceneProductCardSemanticName } from './SceneShelf/index.js'

export { default as MediaEndorsement } from './MediaEndorsement/index.js'
export type {
  MediaEndorsementProps,
  MediaEndorsementData,
  MediaEndorsementItem,
  MediaEndorsementSemanticName,
} from './MediaEndorsement/index.js'

// Copy configuration types and defaults
export type {
  CopyConfig as MediaShelfCopyConfig,
  ButtonFunctionType as MediaShelfButtonFunctionType,
} from './MediaShelf/types.js'
export type { CopyConfig as ActiveShelfCopyConfig, ButtonFunctionType } from './ActiveShelf/types.js'

export {
  default as ImageOverlayShelf,
  type ButtonFunctionType as ImageOverlayShelfButtonFunctionType,
} from './ImageOverlayShelf/index.js'

// MiniCart 组件及类型导出
export { default as MiniCart } from './MiniCart/index.js'
export type { Cart, CartLineItem, MiniCartData, MiniCartProps, CircleProgressConfig } from './MiniCart/index.js'
export { default as MiniCartCircleProgress } from './MiniCart/CircleProgress.js'
export type { CircleProgressProps as MiniCartCircleProgressProps } from './MiniCart/CircleProgress.js'
export { default as MiniCartDialog, MiniCartDialog as MiniCartDialogComponent } from './MiniCart/MiniCartDialog.js'
export type {
  MiniCartDialogProps,
  MiniCartDialogCopy,
  MiniCartDialogSemanticName,
  CartData,
} from './MiniCart/MiniCartDialog.js'

/**
 * 组件映射对象
 */

export const PAYLOAD_COMPONENT_MAP = {
  'ipc-accordioncards': 'AccordionCards',
  'ipc-aplusdesc': 'AplusDesc',
  'ipc-banner': 'HeroBanner',
  'ipc-brand-equity': 'BrandEquity',
  'ipc-category': 'Category',
  'ipc-collection-banner': 'CollectionBanner',
  'ipc-collection-shelves': 'CollectionShelves',
  'ipc-creativemodule': 'CreativeModule',
  'ipc-download': 'DownLoad',
  'ipc-evaluate': 'Evaluate',
  'ipc-faq': 'Faq',
  'ipc-features': 'Features',
  'ipc-footcharger': 'FootCharger',
  'ipc-ga-block': 'GraphicAttractionBlock',
  'ipc-giftbox': 'GiftBox',
  'ipc-giftshelf': 'GiftShelf',
  'ipc-graphic': 'Graphic',
  'ipc-graphicmore': 'GraphicMore',
  'ipc-graphicoverlay': 'GraphicOverlay',
  'ipc-marquee': 'Marquee',
  'ipc-mediaplayerbase': 'MediaPlayerBase',
  'ipc-mediaplayermulti': 'MediaPlayerMulti',
  'ipc-mediaplayersticky': 'MediaPlayerSticky',
  'ipc-member-equity': 'MemberEquity',
  'ipc-mlg-block': 'MultiLayoutGraphicBlock',
  'ipc-search-page-tabs': 'SearchPageBlock',
  'ipc-selectstore': 'SelectStore',
  'ipc-shelfdisplay': 'ShelfDisplay',
  'ipc-slogan': 'Slogan',
  'ipc-spacer': 'Spacer',
  'ipc-specs': 'Specs',
  'ipc-tabs': 'TabsBlock',
  'ipc-text-marquee': 'TextMarquee',
  'ipc-title': 'Title',
  'ipc-whychoose': 'WhyChoose',
  'ipc-product-nav': 'ProductNav',
  'ipc-brand-card-link': 'BrandCardLink',
  'ipc-ipredirect': 'IPRedirect',
  ksp: 'Ksp',
  'ipc-secondary-banner': 'SecondaryBanner',
  /**
   * 活动货架
   */
  'ipc-active-shelf': 'ActiveShelf',
  'ipc-media-shelf': 'MediaShelf',
  /**
   * 活动买赠货架
   */
  'ipc-bogo-shelf': 'BuyOneGetOneShelf',
  'ipc-media-endorsement': 'MediaEndorsement',
  'ipc-media-scene-switcher-v2': 'MediaSceneSwitcherV2',
  'ipc-featured-blog-posts': 'FeaturedBlogPosts',
}
